import { render, staticRenderFns } from "./CreatePlusAppTop.vue?vue&type=template&id=15b1b8f5&scoped=true&"
import script from "./CreatePlusAppTop.vue?vue&type=script&lang=js&"
export * from "./CreatePlusAppTop.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlusAppTop.vue?vue&type=style&index=0&id=15b1b8f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1b8f5",
  null
  
)

export default component.exports